import React from 'react'

export const formatDate = (dateTimeString) => {
  const date = new Date(dateTimeString);
  try {
    return date.toISOString().split('T')[0];
  } catch (error) {
    console.error(error);
    return dateTimeString;
  }
}

export function DateFormatter({dateTimeString}) {
  const formattedDate = formatDate(dateTimeString);
  return <>{formattedDate}</>;
}

